"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendClickStatistics_bd = exports.aClickStatistics_bd = void 0;
var tools_1 = require("./tools");
// 百度统计
/**
 * A元素绑定百度点击统计
 * @param {string} from  pc/m/app
 */
var aClickStatistics_bd = function (from) {
    if (from === void 0) { from = "app"; }
    if (typeof _hmt != "undefined") {
        tools_1.live(document, "a", "click", function (dom) {
            var bdname = dom.getAttribute("data-bdname");
            if (bdname) {
                exports.sendClickStatistics_bd(bdname, { from: from });
            }
        });
    }
};
exports.aClickStatistics_bd = aClickStatistics_bd;
/**
 * 发送百度点击统计请求
 * @param {string} bdname 统计埋点名称 必填
 * @param {Object} {from} 统计来源 默认为app
 */
var sendClickStatistics_bd = function (bdname, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.from, from = _c === void 0 ? "app" : _c;
    if (typeof _hmt != "undefined" && bdname) {
        _hmt.push(["_trackEvent", from, "click", bdname]);
    }
};
exports.sendClickStatistics_bd = sendClickStatistics_bd;
